import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import Calendar from 'react-calendar';
import { unit } from '../../../components/Apis';
import 'react-calendar/dist/Calendar.css';

function UnitCalender({ open, onClose, unitId, rendr }) {
  console.log("Unit Id ", unitId)
  const [unitDetails, setUnitDetails] = useState(null);
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [offDays, setOffDAys] = useState()
  const [reservedDates, setReservedDates] = useState()
  console.log("unit response for calender", unitDetails)
  const fetchUnit = async () => {
    try {
      const response = await unit(unitId);
      console.log(response)
      setUnitDetails(response)
      setStartDate(response.available_from)
      setEndDate(response.available_to)
      setOffDAys(response.off_days)
      setReservedDates(response.reserved_dates)

    } catch (error) {
      console.error('Error fetching unit:', error);
    }
  };

  useEffect(() => {
    fetchUnit()
  }, [unitId])

  const formatDate = (dateStr) => {
    // Convert from "DD-MM-YYYY" to "YYYY-MM-DD"
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  const tileClassName = ({ date }) => {
    const dateStr = date.toLocaleDateString('en-CA'); // gives YYYY-MM-DD in local time

    const formattedOffDays = offDays?.map(day => formatDate(day));
    const formattedReservedDates = reservedDates?.map(day => formatDate(day));

    const availableFrom = startDate ? new Date(startDate).toLocaleDateString('en-CA') : null;
    const availableTo = endDate ? new Date(endDate).toLocaleDateString('en-CA') : null;

    if (formattedOffDays?.includes(dateStr)) {
      return 'off-day';
    }

    if (formattedReservedDates?.includes(dateStr)) {
      return 'reserved-day';
    }

    if (
      availableFrom &&
      availableTo &&
      dateStr >= availableFrom &&
      dateStr <= availableTo
    ) {
      return 'available-day';
    }

    return null;
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ direction: 'ltr' }}>Unit Calendar</DialogTitle>
      <DialogContent sx={{ direction: 'ltr', p: 2 }}>
        <Box sx={{ width: '100%' }}>
          {/* Legend */}
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 16, height: 16, bgcolor: "#9FCBDC", borderRadius: '4px' }} />
              <span>Available Day</span>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 16, height: 16, bgcolor: 'rgba(97, 92, 90, 0.4)', borderRadius: '4px' }} />
              <span>Off Day</span>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 16, height: 16, bgcolor: 'rgba(196, 124, 96, 0.8)', borderRadius: '4px' }} />
              <span>Reserved Day</span>
            </Box>
          </Box>
          <Calendar
            tileClassName={tileClassName}
            className="unit-calendar"
          />
        </Box>

        <style>
          {`
        .unit-calendar {
          width: 100%;
          direction: ltr !important;
          font-size: clamp(0.8rem, 2vw, 1rem);
        }

        .unit-calendar .react-calendar__navigation {
          margin-bottom: 1em;
        }

        .unit-calendar .react-calendar__navigation button {
          min-width: 44px;
          background: none;
          font-size: 1em;
          padding: 0.5em;
        }

        .unit-calendar .react-calendar__month-view__weekdays {
          text-align: center;
          text-transform: uppercase;
          font-weight: bold;
          font-size: 0.8em;
          margin-bottom: 0.5em;
        }

        .unit-calendar .react-calendar__month-view__days {
          display: grid !important;
          grid-template-columns: repeat(7, 1fr) !important;
          gap: 4px;
          justify-content: center;
          margin-inline: 7px;
          margin-bottom: 15px;
        }

        .unit-calendar .react-calendar__month-view__days__day {
          padding: 0.5em;
          aspect-ratio: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 2px;
          border-radius: 4px;
          transition: all 0.2s ease;
          width: 100% !important;
        }

        .unit-calendar .react-calendar__month-view__days__day:hover {
          background-color: #948979;
        }

        .unit-calendar .available-day {
          background-color: #9FCBDC !important;
          color: white !important;
          border-radius: 4px;
        }

        .unit-calendar .off-day {
          background-color:rgba(97, 92, 90, 0.4) !important;
          color: white !important;
          border-radius: 4px;
        }

        .unit-calendar .reserved-day {
          background-color:rgba(196, 124, 96, 0.78) !important;
          color: white !important;
          border-radius: 4px;
        }

        .unit-calendar .react-calendar__month-view__days__day--weekend {
          color: #000000 !important;
        }

        .unit-calendar .react-calendar__tile--now {
          background: none !important;
          color: inherit !important;
          border: 2px solid #9FCBDC !important;
          border-radius: 4px;
        }

        .unit-calendar .react-calendar__month-view__days__day--neighboringMonth {
          opacity: 0.5;
        }

        @media (max-width: 600px) {
          .unit-calendar .react-calendar__month-view__days__day {
            padding: 0.2em;
            margin: 1px;
          }
          
          .unit-calendar .react-calendar__navigation button {
            min-width: 36px;
            padding: 0.3em;
          }
        }
      `}
        </style>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnitCalender;
